/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserSimpleResource } from '../models/UserSimpleResource';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class UsersImpersonationService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get token of another user.
     * Current user must be able to impersonate
     * @returns any OK
     * @throws ApiError
     */
    public impersonateUser({
        id,
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number,
    }): CancelablePromise<{
        data: {
            access_token: string;
            users: Array<UserSimpleResource>;
        };
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/impersonate/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Returns the token of the user who began impersonation
     * @returns any OK
     * @throws ApiError
     */
    public leaveImpersonation(): CancelablePromise<{
        data: {
            access_token: string;
        };
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/leaveImpersonation',
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
            },
        });
    }

}
